export const UPDATE_TIME = `UPDATE_TIME`;
export const CHANGE_SONG = `CHANGE_SONG`;
export const PLAY_SONG = `PLAY_SONG`;
export const PLAY_SONG_TIME = `PLAY_SONG_TIME`;
export const TOGGLE_PLAY = `TOGGLE_PLAY`;
export const PAUSE_PLAY = `PAUSE_PLAY`;
